import { InventoryDashboardLowStockRow } from '@/renderer/types/inventory';
import React from 'react';
import { formatCompactCurrency, formatQuantity } from './inventoryDashboard';

interface InventoryDashboardLowStockCardProps {
  rows: InventoryDashboardLowStockRow[];
}

export function InventoryDashboardLowStockCard({
  rows,
}: InventoryDashboardLowStockCardProps) {
  const headline = rows.length
    ? `${rows.length} items need attention.`
    : 'All tracked items are above their reorder levels.';

  return (
    <div className="rounded-[22px] border border-gray-200 bg-white p-3.5 shadow-sm">
      <div>
        <p className="text-sm font-semibold text-slate-900">Low-stock watch</p>
        <p className="mt-1 text-xs text-slate-500">{headline}</p>
      </div>

      {rows.length ? (
        <div className="mt-3 overflow-hidden rounded-xl border border-gray-100">
          <div className="grid grid-cols-[minmax(0,1.4fr)_110px_110px_130px] gap-3 border-b border-gray-100 bg-slate-50 px-4 py-3 text-xs font-semibold uppercase tracking-[0.18em] text-slate-500">
            <span>Item</span>
            <span className="text-right">On hand</span>
            <span className="text-right">Reorder</span>
            <span className="text-right">Value</span>
          </div>
          <div className="max-h-[260px] overflow-y-auto">
            {rows.map((row) => (
              <div
                key={`${row.stock_location_id}-${row.inventory_item_id}`}
                className="grid grid-cols-[minmax(0,1.4fr)_110px_110px_130px] gap-3 border-b border-gray-100 px-4 py-3 text-sm last:border-b-0"
              >
                <div className="min-w-0">
                  <p className="truncate font-medium text-slate-900">
                    {row.item_name}
                  </p>
                  <p className="truncate text-xs text-slate-500">
                    {row.stock_location_name}
                    {row.sku ? ` • ${row.sku}` : ''}
                  </p>
                </div>
                <span className="text-right font-medium text-amber-700">
                  {formatQuantity(row.quantity_on_hand)}
                </span>
                <span className="text-right text-slate-600">
                  {formatQuantity(row.reorder_level)}
                </span>
                <span className="text-right text-slate-600">
                  {formatCompactCurrency(row.total_value)}
                </span>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div className="mt-3 rounded-xl border border-dashed border-gray-200 bg-slate-50 px-4 py-6 text-sm text-slate-500">
          Nothing is below reorder level right now.
        </div>
      )}
    </div>
  );
}
